// assets
import { DashboardOutlined } from '@ant-design/icons';
import Person3Icon from '@mui/icons-material/Person3';

// icons
const icons = {
  DashboardOutlined,
  Person3Icon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    
  ]
};

export default dashboard;
